<div class="key-ingdreients-container">
    <div class="d-flex" style="justify-content:space-evenly ;padding: 10px;">

        <div (click)="goToStep1()">
            <div *ngIf="step1">
                <img src="assets/img/key_ingredients-active.svg" alt="">
            </div>
            <div *ngIf="!step1">
                <img src="assets/img/key_ingredients-inactive.svg" alt="">
            </div>
        </div>

        <div (click)="goToStep2()" *ngIf="nutriInfoFlag">
            <div *ngIf="!step2">
                <img src="assets/img/nutritional_info-inactive.svg" alt="">
            </div>
            <div *ngIf="step2">
                <img src="assets/img/nutritional_info-active.svg" alt="">
            </div>
        </div>

        <div (click)="goToStep3()">
            <div *ngIf="!step3">
                <img src="assets/img/ratings_review-inactive.svg" alt="">
            </div>
            <div *ngIf="step3">
                <img src="assets/img/reviews_ratings-active.svg" alt="">
            </div>
        </div>

        <div (click)="goToStep4()">
            <div *ngIf="!step4">
                <img src="assets/img/dish_details-inactive.svg" alt="">
            </div>
            <div *ngIf="step4">
                <img src="assets/img/dish_details-active.svg" alt="">
            </div>
        </div>

        <div (click)="goToStep5()">
            <div *ngIf="!step5">
                <img src="assets/img/media-inactive.svg" alt="">
            </div>
            <div *ngIf="step5">
                <img src="assets/img/media-active.svg" alt="">
            </div>
        </div>
    </div>

    <div>
        <div *ngIf="step1" style="padding: 0px 10px 10px 10px;">
            <div class="title-underline">
                &nbsp;
            </div>
            <div class="step-title">Key Ingredients</div>
            <div>


                <div class="pad-top-10 pad-bottom-10" *ngIf="fruitsAndVegetablesFlag">
                    <div class="key-ingredients-title col-9">
                        Fruits and Vegetables
                    </div>
                    <div class="d-flex justify-content-between pad-bottom-5" *ngFor="let item of fruitsAndVegetables">
                        <div class="key-ingredients-name col-9"
                            [ngClass]="{'text-green':item.like == 'Yes', 'text-red': item.dislike == 'Yes', 'text-gray': item.dislike == 'No' && item.like == 'No'}">
                            {{item.sub_ingredient_name}}
                        </div>
                        <div class="d-flex col-3 justify-content-between">
                            <div>
                                <img src="assets/img/like-grey.svg" alt="" *ngIf="item.like == 'No'"
                                    (click)="postLikes(item.sub_ingredient_name)">
                                <img src="assets/img/green-like.svg" alt="" *ngIf="item.like == 'Yes'">
                            </div>
                            <div>
                                <img src="assets/img/dislike-grey.svg" alt="" *ngIf="item.dislike == 'No'"
                                    (click)="postDisLikes(item.sub_ingredient_name)">
                                <img src="assets/img/dislike-red.svg" alt="" *ngIf="item.dislike == 'Yes'">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pad-bottom-10" *ngIf="spicesAndHerbsFlag">
                    <div class="key-ingredients-title col-9">
                        Spices and Herbs
                    </div>
                    <div class="d-flex justify-content-between pad-bottom-5" *ngFor="let item of spicesAndHerbs">
                        <div class="key-ingredients-name col-9"
                            [ngClass]="{'text-green':item.like == 'Yes', 'text-red': item.dislike == 'Yes', 'text-gray': item.dislike == 'No' && item.like == 'No'}">
                            {{item.sub_ingredient_name}}
                        </div>
                        <div class="d-flex col-3 justify-content-between">
                            <div>
                                <img src="assets/img/like-grey.svg" alt="" *ngIf="item.like == 'No'"
                                    (click)="postLikes(item.sub_ingredient_name)">
                                <img src="assets/img/green-like.svg" alt="" *ngIf="item.like == 'Yes'">
                            </div>
                            <div>
                                <img src="assets/img/dislike-grey.svg" alt="" *ngIf="item.dislike == 'No'"
                                    (click)="postDisLikes(item.sub_ingredient_name)">
                                <img src="assets/img/dislike-red.svg" alt="" *ngIf="item.dislike == 'Yes'">
                            </div>
                        </div>
                    </div>
                </div>

                <div class=" pad-bottom-10" *ngIf="cerealsAndPulsesFlag">
                    <div class="key-ingredients-title col-9">
                        Cereals and Pulses
                    </div>
                    <div class="d-flex justify-content-between pad-bottom-5" *ngFor="let item of cerealsAndPulses">
                        <div class="key-ingredients-name col-9"
                            [ngClass]="{'text-green':item.like == 'Yes', 'text-red': item.dislike == 'Yes', 'text-gray': item.dislike == 'No' && item.like == 'No'}">
                            {{item.sub_ingredient_name}}
                        </div>
                        <div class="d-flex col-3 justify-content-between">
                            <div>
                                <img src="assets/img/like-grey.svg" alt="" *ngIf="item.like == 'No'"
                                    (click)="postLikes(item.sub_ingredient_name)">
                                <img src="assets/img/green-like.svg" alt="" *ngIf="item.like == 'Yes'">
                            </div>
                            <div>
                                <img src="assets/img/dislike-grey.svg" alt="" *ngIf="item.dislike == 'No'"
                                    (click)="postDisLikes(item.sub_ingredient_name)">
                                <img src="assets/img/dislike-red.svg" alt="" *ngIf="item.dislike == 'Yes'">
                            </div>
                        </div>
                    </div>
                </div>

                <div class=" pad-bottom-10" *ngIf="othersFlag">
                    <div class="key-ingredients-title col-9">
                        Others
                    </div>
                    <div class="d-flex justify-content-between pad-bottom-5" *ngFor="let item of others">
                        <div class="key-ingredients-name col-9"
                            [ngClass]="{'text-green':item.like == 'Yes', 'text-red': item.dislike == 'Yes', 'text-gray': item.dislike == 'No' && item.like == 'No'}">
                            {{item.sub_ingredient_name}}
                        </div>
                        <div class="d-flex col-3 justify-content-between">
                            <div>
                                <img src="assets/img/like-grey.svg" alt="" *ngIf="item.like == 'No'"
                                    (click)="postLikes(item.sub_ingredient_name)">
                                <img src="assets/img/green-like.svg" alt="" *ngIf="item.like == 'Yes'">
                            </div>
                            <div>
                                <img src="assets/img/dislike-grey.svg" alt="" *ngIf="item.dislike == 'No'"
                                    (click)="postDisLikes(item.sub_ingredient_name)">
                                <img src="assets/img/dislike-red.svg" alt="" *ngIf="item.dislike == 'Yes'">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nutri-not-available"
                    *ngIf="!fruitsAndVegetablesFlag && !spicesAndHerbsFlag && !cerealsAndPulsesFlag && !othersFlag">
                    No ingredient details available.
                </div>
            </div>
        </div>

        <div *ngIf="step2">
            <div class="title-underline">
                &nbsp;
            </div>
            <div class="step-title">Nutritional Info</div>

            <div class="nutri-not-available">Nutritional info currently not available</div>
        </div>

        <div *ngIf="step3">
            <div class="title-underline">
                &nbsp;
            </div>
            <div class="step-title">Reviews and Ratings</div>
            <div *ngIf="showReviewsAndRatings">
                <div class="dish-title-ratings">{{foodDishName}}</div>
                <div class="taste-ratings-div" (click)="gotoTasteRatingsPage(foodDishName)" style="cursor: pointer;">
                    <div class="d-flex space-between">
                        <div class="taste-ratings-reviews">
                            Taste Ratings & Reviews
                        </div>
                        <div class="ratings-count">
                            {{total_rating_count}} ratings & {{total_review_count}} reviews <span><img
                                    src="assets/img/right-icons.svg" alt=""
                                    (click)="gotoTasteRatingsPage(foodDishName)"></span>
                        </div>
                    </div>
                </div>

                <div class="padding-div">
                    <div class="d-flex space-between">
                        <div>
                            <mat-radio-button color="primary" style="padding-left: 10px" (click)="checkOverAll()"
                                [checked]='true'>
                                Overall
                            </mat-radio-button>
                        </div>
                        <div>
                            <mat-radio-button color="primary" style="padding-left: 10px" (click)="checkPersonalized()">
                                Personalised
                            </mat-radio-button>
                        </div>
                        <div ngbTooltip="This is unsuitable as per your dietary preferences" placement="bottom"
                            triggers="hover">
                            <button class="btn-allergen" type="button"><img src="assets/img/hover-icon.svg"
                                    alt=""></button>
                        </div>
                    </div>

                    <div class="d-flex excellent-div">
                        <div class="star-icon">
                            <img src="assets/img/start-icon.svg" alt="">
                        </div>
                        <div *ngIf="overallBool">
                            <span class="ratings-count-number">{{overAllRating}}</span> <em
                                class="excellent">{{overAllText}}</em>
                        </div>
                        <div *ngIf="personalisedBool">
                            <span class="ratings-count-number">{{personalisedRating}}</span> <em
                                class="excellent">{{personalised_text}}</em>
                        </div>
                    </div>
                </div>

                <div class="allergy-ratings-div" (click)="gotoAllergyRatingsPage(foodDishName)"
                    style="cursor: pointer;">
                    <div class="d-flex space-between">
                        <div class="taste-ratings-reviews">
                            Allergy Ratings
                        </div>
                        <div class="ratings-count">
                            View all <span><img src="assets/img/right-icons.svg" alt=""></span>
                        </div>
                    </div>
                </div>

                <div class="padding-div">
                    <div class="d-flex">
                        <div class="zero-padding">
                            <div class="zero-out-zero">
                                {{review_total}} out of {{review_total}}
                            </div>
                            <div class="safe-text">
                                <em>Found this {{review_code}}</em>
                            </div>
                        </div>

                        <div class="d-flex margl-10 ">
                            <div class="people-with-allergy">
                                People with Allergy
                            </div>
                            <div class="margl-10 ">
                                <ng-select [(ngModel)]="allergenss_name" name="allergenss_name"
                                    [items]="allergensListArray" bindLabel="allergens_name" bindValue="allergens_id"
                                    [multiple]="false" [clearable]="false" [virtualScroll]="true">
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!showReviewsAndRatings">
                <div class="nutri-not-available">
                    No Ratings and Reviews found for this dish.
                </div>
            </div>
        </div>

        <div *ngIf="step4" style="padding: 0px 10px 10px 10px;">
            <div class="title-underline">
                &nbsp;
            </div>
            <div class="step-title">Dish Details</div>
            <div>
                <div class="d-flex pad-bottom-5 pad-top-10">
                    <div class="col-5 dish-title">Name</div>
                    <div class="dishDescription"> {{DishIdName}}</div>
                </div>

                <div class="d-flex pad-bottom-5">
                    <div class="col-5 dish-title">Details</div>
                    <div class="dishDescription"> {{description}}</div>
                </div>

                <div class="d-flex pad-bottom-5">
                    <div class="col-5 dish-title">Ingredients</div>
                    <div class="dishDescription"> {{ingredients?ingredients : 'NA'}}</div>
                </div>

                <div class="d-flex pad-bottom-5">
                    <div class="col-5 dish-title">Price</div>
                    <div class="dishDescription"> {{price}}</div>
                </div>

                <div class="d-flex pad-bottom-5">
                    <div class="col-5 dish-title">Allergens</div>
                    <div *ngFor="let item of allergens" class="dishDescription"> {{item.allergens_name}}</div>
                </div>

                <div class="d-flex pad-bottom-5">
                    <div class="col-5 dish-title">Allergen options</div>
                    <div *ngFor="let item of allergensOptions" class="dishDescription"> {{item.allergens_name}}</div>
                </div>

                <div class="d-flex pad-bottom-5">
                    <div class="col-5 dish-title">unsuitable dietary</div>
                    <div *ngFor="let item of unsuitableDietary" class="dishDescription"> {{item.diet_preference_name}}
                    </div>
                </div>

                <div class="d-flex pad-bottom-5">
                    <div class="col-5 dish-title">Dietary options</div>
                    <div *ngFor="let item of unsuitableDietaryOption" class="dishDescription">
                        {{item.diet_preference_name}}</div>
                </div>

                <div class="d-flex pad-top-5">
                    <div class="col-5 dish-title">Tags</div>
                    <div *ngFor="let item of tags" class="dishDescription"> {{item.tag_name}}</div>
                </div>

            </div>
        </div>
        <div *ngIf="step5">
            <div class="title-underline">
                &nbsp;
            </div>
            <div class="step-title">Media</div>
            <div *ngIf="mediaFlag" style="    max-height: 250px;overflow: hidden;">
                <div class="media-subHead">
                    <div>
                        <span class="imgSpan" [ngClass]="imageFlag ? 'activeCss':'' "
                            (click)="mediaChangeFunc('img')">Image </span>
                    </div>
                    <div>
                        <span class="audioSpan imgSpan" [ngClass]="imageFlag ? '':'activeCss' "
                            (click)="mediaChangeFunc('audio')">Audio</span>
                    </div>
                </div>
                <div *ngIf="imageFlag">
                    <div *ngIf="!imgLoadFlag">
                        <img src="../../../../assets/img/Spinner-5.gif" alt="" class="dishImg-media"
                            style="padding:29px; margin-bottom: 200px;">
                    </div>
                    <img [src]="dishImage" (load)="imgLoadFlag = true"  alt="" srcset=""
                        class="dishImg-media">
                </div>
                <div *ngIf="!imageFlag">
                    <div class="nutri-not-available">
                        No Audio Available.
                    </div>  
                </div>
            </div>
            <div *ngIf="!mediaFlag">
                <div class="nutri-not-available">
                    No Media Found.
                </div>
            </div>
        </div>
    </div>

    <style>
        .dishImg-media {
            max-width: 50%;
            max-height: 126px;
            margin: auto;
            display: block;
            border: 1px solid #BABABA;
            border-radius: 10px;
        }

        .media-subHead {
            display: grid;
            grid-template-columns: 1fr 2fr;
        }

        .media-subHead div {
            padding-left: 15%;
            margin: 10px 0px 20px 0px;
        }

        .imgSpan {
            color: #4E4E4E;
            font-size: 18px;
            display: inline-block;
            width: 100%;
            text-align: center;
            padding-bottom: 7px;
            cursor: pointer;
        }

        .audioSpan {
            max-width: 50%;
        }

        .activeCss {
            color: #54AC58;
            border-bottom: 2px solid #54AC58;
        }

        ::ng-deep.mat-bottom-sheet-container {
            padding: 0px !important;
            box-sizing: border-box;
            display: block;
            outline: 0;
            max-height: 600vh !important;
            overflow: auto;
            border-top-left-radius: 16px !important;
            border-top-right-radius: 16px !important;
        }

        ::ng-deep.mat-bottom-sheet-container-large {
            min-width: 380px;
            max-width: 380px;
            min-height: 100px !important;
            max-height: 300px !important;
        }

        .zero-out-zero {
            border: 1px solid #54AC58;
            background: #F4FFF4;
            color: #4E4E4E;
            font-size: 13px;
            line-height: 18px;
            font-family: 'Roboto';
            font-weight: 400;
            border-radius: 15px;
            padding: 3px;
            width: 99px;
            height: 26px;
            text-align: center;
        }

        .people-with-allergy {
            color: #4E4E4E;
            font-size: 13px;
            line-height: 18px;
            font-family: 'Roboto';
            font-weight: 400;
        }

        .safe-text {
            color: #707070;
            font-size: 14px;
            line-height: 19px;
            font-family: 'Roboto';
        }

        ::ng-deep.mat-bottom-sheet-container-xlarge {
            min-width: 380px !important;
            max-width: 380px;
        }

        .zero-padding {
            padding-left: 10px;
        }

        .padding-div {
            padding: 20px;
        }

        ::ng-deep::-webkit-scrollbar {
            display: none !important;
        }

        .margl-10 {
            margin-left: 10px;
        }

        .key-ingdreients-container {
            /* padding: 10px; */
            height: 300px;
            overflow: scroll;
        }

        .excellent-div {
            padding-top: 10px;
        }

        .excellent {
            color: #707070;
            font-size: 13px;
            line-height: 18px;
        }

        .star-icon img {
            width: 15px;
            margin-left: 8px;
            margin-top: -3px;
        }

        .title-underline {
            border-bottom: 3px solid #EFEFEF;
        }

        .ratings-count-number {
            color: #707070;
            font-size: 13px;
            line-height: 18px;
            font-family: 'Roboto';
            font-weight: 450;
            padding: 5px 5px 0px 5px;
        }

        .step-title {
            font-size: 18px;
            line-height: 23px;
            color: #54AC58;
            font-weight: 500;
            display: flex;
            justify-content: center;
            padding: 5px 0px 5px 0px;
            border-bottom: 2px solid #EFEFEF;
        }

        img {
            cursor: pointer;
        }

        .nutri-not-available {
            color: #70707080;
            font-size: 14px;
            font-family: 'Roboto';
            line-height: 19px;
            display: flex;
            justify-content: center;
            padding-top: 10%;
        }

        .taste-ratings-div {
            background: #F2F5F7;
            padding: 9px 30px 7px 30px;
        }

        ::ng-deep .mat-radio-button.mat-primary.mat-radio-checked .mat-radio-outer-circle {
            border-color: #54AC58;
        }

        ::ng-deep .mat-radio-button.mat-primary .mat-radio-inner-circle {
            background-color: #54AC58;
        }

        ::ng-deep.mat-radio-outer-circle {
            width: 18px !important;
            height: 18px !important;
        }

        ::ng-deep.mat-radio-inner-circle {
            width: 18px !important;
            height: 18px !important;
        }

        ::ng-deep .mat-radio-label-content {
            -webkit-user-select: auto;
            -moz-user-select: auto;
            -ms-user-select: auto;
            user-select: auto;
            display: inline-block;
            order: 0;
            color: #4E4E4E !important;
            line-height: inherit;
            padding-left: 10px !important;
            padding-right: 0;
            font-size: 13px;
            line-height: 18px;
        }

        .allergy-ratings-div {
            background: #F2F5F7;
            padding: 9px 30px 7px 30px;
        }

        .taste-ratings-reviews {
            color: #707070;
            font-size: 14px;
            letter-spacing: 0.3px;
            line-height: 19px;
            font-family: 'Roboto';
            font-weight: 450;
        }

        .ratings-count {
            color: #707070;
            font-size: 11px;
            line-height: 15px;
            font-family: 'Roboto';
            padding-top: 3px;
        }

        .ratings-count img {
            margin-left: 10px;
            cursor: pointer;
        }

        .btn-allergen {
            border: none;
            background: transparent;
        }

        .btn-allergen img {
            width: 18px;
            margin-top: -7px;
        }

        .dish-title,
        .key-ingredients-title {
            color: #4E4E4E;
            font-size: 14px;
            font-weight: 500;
            line-height: 19px;
            font-family: 'Roboto';
        }

        .dishDescription,
        .key-ingredients-name {
            color: #707070;
            font-size: 14px;
            font-family: 'Roboto';
            line-height: 19px;
        }

        .pad-top-10 {
            padding-top: 10px;
        }

        .pad-bottom-10 {
            padding-bottom: 10px;
        }

        .pad-bottom-5 {
            padding-bottom: 5px;
        }

        .dish-title-ratings {
            color: #3C3C3C;
            font-size: 16px;
            letter-spacing: 0.2px;
            line-height: 21px;
            font-weight: 500;
            font-family: 'Roboto';
            display: flex;
            justify-content: center;
            padding: 5px 0px 5px 0px;
        }

        .space-between {
            justify-content: space-between;
        }

        .text-green {
            color: #54AC58;
        }

        .text-red {
            color: #FA4747;
        }

        .text-gray {
            color: #707070;
        }
    </style>